// Seed vocabulary of common roofing / construction job titles. These are
// always offered as suggestions (not stored, not deletable); workspace-added
// custom titles from the API are merged on top. `user.title` stays a free
// string — this list only powers the picker.
export const DEFAULT_JOB_TITLES: string[] = [
  "Owner",
  "General Manager",
  "Operations Manager",
  "Sales Manager",
  "Sales Representative",
  "Account Executive",
  "Appointment Setter",
  "Canvasser",
  "Estimator",
  "Project Manager",
  "Production Manager",
  "Field Supervisor",
  "Superintendent",
  "Foreman",
  "Crew Lead",
  "Roofer",
  "Installer",
  "Inspector",
  "Office Manager",
  "Administrative Assistant",
];

/** Case-insensitive, whitespace-tolerant key for de-duping titles across the
 * seed list and workspace-added custom titles. */
export function jobTitleKey(name: string): string {
  return name.trim().toLowerCase();
}
